import { liveTickerItems } from "@/mocks/home";

export default function LiveTicker() {
  const loopItems = [...liveTickerItems, ...liveTickerItems];

  return (
    <div className="flex w-full items-center gap-4 border-b border-primary-800 bg-primary-900 py-2.5 text-background-100">
      <div className="flex shrink-0 items-center gap-2 pl-4 md:pl-10">
        <span className="relative flex h-2 w-2 items-center justify-center">
          <span className="absolute inline-flex h-2 w-2 animate-live-dot rounded-full bg-accent-400"></span>
        </span>
        <span className="whitespace-nowrap text-xs font-medium tracking-wide">实时热传</span>
      </div>

      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee items-center">
          {loopItems.map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="flex items-center gap-2 whitespace-nowrap px-5 text-xs text-background-200/85"
            >
              <i className="ri-flashlight-fill text-accent-400"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}